/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLog.defs.js'
export { main as default } from './getLog.defs.js'
